import React from "react"

import ListWidgetHeader from "../../common/ListWidgetHeader"
import SearchBar from "../../common/SearchBar"

import UserListContainer from "./UserListContainer"

const UserListWidget = ({
    onFilterSelect,
    canAdd,
    isFetching,
    invalidate,
    pagingRequest,
    nameSearchTerm,
    onSearch,
    onAdd
}) => (
    <div className="widget">
        <ListWidgetHeader
            isFetching={isFetching}
            canAdd={canAdd}
            iconComponent={<span className="icon icon-community-people" />}
            listTitle="Users"
            invalidate={invalidate(pagingRequest)}
            onAdd={onAdd}
            onFilterSelect={onFilterSelect(pagingRequest)}
        />
        <div className="quick-filters">
            <SearchBar searchTerm={nameSearchTerm} onSearch={onSearch} />
        </div>
        <UserListContainer />
    </div>
)

export default UserListWidget
